import React, { useContext } from 'react';
import _ from 'lodash';
import { H3, SpacingBox, Dropdown } from '../../Components';
import { getSeasons } from '../../selectors';
import { getTranslateByScope } from '../../i18n';
import AppContext from '../../AppContext';

const translate = getTranslateByScope('app.seasonsDropdown');

const mapSeasonsDropdown = (seasons) => {
  if (!seasons || seasons === {}) return [];

  const seasonValues = _.filter(_.values(seasons), (f) => _.get(f, 'season_code'));

  return seasonValues.map((s) => ({
    label: `${s.name}  • ${s.season_code}`,
    value: s.season_code,
  }));
};

export const Title = () => (
  <SpacingBox marginBottom="md">
    <H3>{translate('title')}</H3>
  </SpacingBox>
);

export const SeasonsDropdown = ({ selectSeason }) => {
  const context = useContext(AppContext);
  const seasons = getSeasons(context);
  return (
    <Dropdown onChange={selectSeason} options={mapSeasonsDropdown(seasons)} />
  );
};

export default ({ selectSeason }) => (
  <SpacingBox marginBottom="xl" marginTop="md">
    <Title />
    <SeasonsDropdown selectSeason={({ value }) => selectSeason(value)} />
  </SpacingBox>
);
